import React, { useMemo } from 'react'
import { usePipelineDataContextWithVariables } from '../../../provider/DDPDataProvider'
import { useVisualBlocksContext } from '../VisualBlocksContext'
import { useColumns } from '../../../presentationTable/PipelinePresentationTable'
import OpalPresentationTable, { usePresentationTableExpandState } from '../../../../DenaliAnalysis/tables/presentation'
import { useHideIfNoDataWhen } from '../../../../HideIfNoData'

function DrilldownTable () {
  const { ddPipeline, ddVariablesContext, filterTable, drilldownKeyAccessor } = useVisualBlocksContext()
  const { data, isLoading, isError } = usePipelineDataContextWithVariables(ddPipeline, ddVariablesContext)
  const ddTableData = useMemo(() => {
    if (!data || isLoading) return []
    return filterTable ? (data.data.find(i => i[drilldownKeyAccessor] === filterTable)?.data || []) : data.data
  }, [data, isLoading, filterTable, drilldownKeyAccessor])

  const { columns, defaultSort, includeFooter } = useColumns(ddVariablesContext.columns, ddTableData?.total || [])
  useHideIfNoDataWhen(() => !isLoading && !ddTableData?.length, [ddTableData, isLoading])
  const { expandState, setExpandState } = usePresentationTableExpandState(true)

  if (isError) {
    return <div className='p-4'>Error loading data.</div>
  }
  return (
    <>
      <OpalPresentationTable
        data={ddTableData || []}
        columns={columns ?? []}
        defaultSort={defaultSort}
        includeHeader
        includeFooter={includeFooter}
        expandState={expandState}
        onExpandStateChange={setExpandState}
        isLoading={isLoading}
        emptyStateText='No details available'
      />
    </>
  )
}
export default DrilldownTable
